<button
  class="login-secondary-button"
  *ngIf="type === 'route'"
  color="accent"
  mat-flat-button
  routerLinkActive="router-link-active"
  [routerLink]="[dynamicRoute]"
>
  <mat-icon>{{ icon }}</mat-icon>
  {{ label }}
</button>
<button *ngIf="type !== 'route'" color="basic" extended mat-fab>
  <mat-icon>{{ icon }}</mat-icon>
  {{ label }}
</button>
